var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isVisible
      ? _c("div", { staticClass: "vod-controls" }, [
          _vm.title
            ? _c("div", { staticClass: "vod-controls__title" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "vod-controls__bar" }, [
            _c("div", { staticClass: "vod-controls__time" }, [
              _vm._v(_vm._s(_vm.getElapsed))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vod-controls__progress" }, [
              _c("div", {
                staticClass: "vod-controls__progress-fill",
                style: { width: _vm.getProgress + "%" }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "vod-controls__progress-knob",
                style: { left: _vm.getProgress + "%" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vod-controls__time" }, [
              _vm._v(_vm._s(_vm.getDuration))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "vod-controls__buttons" },
            _vm._l(_vm.getButtons, function(button) {
              return _c(
                "span",
                {
                  key: button.key,
                  staticClass: "vod-controls__button",
                  class: { "vod-controls__button--active": button.isActive }
                },
                [
                  _c("span", { staticClass: "vod-controls__glyph" }, [
                    _vm._v(_vm._s(button.glyph))
                  ]),
                  _vm._v(" "),
                  button.speed
                    ? _c("span", { staticClass: "vod-controls__speed" }, [
                        _vm._v(
                          "\n          " + _vm._s(button.speed) + "\n        "
                        )
                      ])
                    : _vm._e()
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "vod-controls__hint" }, [
            _vm._v(_vm._s(_vm.getHint))
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0619da4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0619da4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer/VodControls.vue
// module id = null
// module chunks = 